<!--
 * @Author: Code-HHX
 * @Date: 2022-04-12 15:10:41
 * @LastEditors: Code-HHX
 * @LastEditTime: 2022-05-11 14:30:01
 * @Description: 首页/登录页面
-->
<template>
  <div class="container">
    <div class="header" v-if="step > 1">
      <van-icon
          class="header-return"
          name="arrow-left"
          size="25"
          color="#333333"
          @click="onClickHeaderReturn()"
      />
    </div>

    <div class="content">
      <van-form ref="emailForm" :show-error-message="false" validate-trigger="onChange">

        <van-field v-if="step === 1"
            v-model="email"
            name="email"
            ref="email"
            :rules="[{ validator:emailValidator}]"
            placeholder="Email">
          <template #button>
            <van-image :src="require('@/assets/icons/v2/ic_login_next.svg')" width="24px" height="24px"
                @click="onEmailNext"/>
          </template>
        </van-field>

      </van-form>

      <van-form ref="verificationForm" :show-error-message="false" validate-trigger="onChange" v-if="step === 2">

        <van-field
            v-model="email"
            name="emailCode"
            ref="emailCode"
            disabled
            placeholder="Send Verification">
          <template #button>
            <van-image :src="require('@/assets/icons/v2/ic_login_next.svg')" width="24px" height="24px"
                @click="onSendEmailVerification"/>
          </template>
        </van-field>
        <OtpCode ref="otp1" key="otp1" label="Verification Code" @value="onRegisterEmailCodeChange"
            @complete="onCompleteVerificationCode"/>

      </van-form>


      <van-form ref="passwordForm" v-if="step === 3">
        <van-field
            v-model="password"
            name="password"
            ref="password"
            :type="passwordType"
            :rules="[{ validator:passwordValidator}]"
            placeholder="Password">
          <template #button>
            <van-image :src="require('@/assets/icons/v2/ic_login_eye.svg')" width="24px" height="24px"
                class="mr-3"
                @click="onClickEye"/>
            <van-image :src="require('@/assets/icons/v2/ic_login_next.svg')" width="24px" height="24px"
                @click="onPasswordNext"/>
          </template>
        </van-field>


        <OtpCode ref="otp2" key="otp2" v-if="userStatus.invitationCodeStatus === 0 && !isForgetPassword"
            id="invitationCodeOtp"
            label="Invitation Code"
            @value="onInvitationCodeChange"
        />
        <div class="horizontal w-full items-center justify-center mt-6 text-14px"
            @click="onForgetPasswordClick" v-if="!isForgetPassword">Forget password
        </div>
      </van-form>


      <van-form ref="renterPasswordForm" :show-error-message="false" validate-trigger="onChange" v-if="step === 4">

        <van-field
            v-model="confirmPassword"
            name="confirmPassword"
            ref="confirmPassword"
            :type="confirmPasswordType"
            :rules="[{ validator:confirmPasswordValidator}]"
            placeholder="Renter Password">
          <template #button>
            <van-image :src="require('@/assets/icons/v2/ic_login_eye.svg')" width="24px" height="24px"
                class="mr-3"
                @click="onClickConfirmEye"/>
            <van-image :src="require('@/assets/icons/v2/ic_login_next.svg')" width="24px" height="24px"
                @click="onRenterPasswordNext"/>
          </template>
        </van-field>

      </van-form>


    </div>


    <div class="footer" v-if="false">
      Powered by OMNI
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { TOKEN } from "@/config/http-json";
import VerifyAge from "@/components/VerifyAge.vue";
import OtpInput from "@/components/common/OtpInput.vue";
import OtpCode from "@/components/common/OtpCode.vue";
import user from "@/api/user";

export default {
  name: "Login",
  components: { OtpCode, VerifyAge, OtpInput },
  data() {
    return {
      email: "",
      password: "",
      invitationCode: "",
      emailCode: "",
      confirmPassword: "",

      // email: "ikrusher",
      // password: "123456",
      passwordVisible: false,
      confirmPasswordVisible: false,
      userStatus: 0,
      passwordType: "password",
      confirmPasswordType: "password",
      step: 1,
      isCaptchaSumbiting: false,
      isForgetPassword: false
    };
  },
  created() {
    if (process.env.NODE_ENV === "dev") {
      this.email = "123456@qq.com";
      // this.email = "brand@ikrusher.com";
      // this.password = "brand123456";
      // this.email = "test@plugplay.com";
      // this.email = "test@trulieve.com";
      this.password = "123456";
    }
    let token = window.localStorage.getItem(TOKEN);
    if (token) {
      // if (navigator.nfcReader) {
      //   this.$router.replace("Function");
      // }else {
      //   this.$router.replace("NewHome");
      // }
      this.$router.replace({ name: "Enterprise", query: { hash: this.$store.state.hash } });
    }
  },
  computed: {

    ...mapState("theme", ["themeMainColor"]),
    ...mapState(["brandImage", "checkPrivacy"])
  },
  methods: {
    ...mapActions(["_setLoginInfo"]),
    async onForgetPasswordClick() {
      try {
        const resp = await user.sendEmailV2({
          email: this.email
        }, true);
        if (resp.code !== 200) {
          this.$toast({
            type: 'fail',
            message: resp.message
          });
          return;
        }
        this.isForgetPassword = true;
        this.step = 2;
      } catch (e) {
        this.$toast({
          type: 'fail',
          message: e
        });
      }

    },
    onClickHeaderReturn() {
      if (this.step === 3) {
        this.step -= 2;
        if (this.isForgetPassword) {
          this.isForgetPassword = false
        }
      } else if (this.step === 2) {
        this.step -= 1;
        if (this.isForgetPassword) {
          this.isForgetPassword = false
        }
      } else {
        this.step -= 1;
      }
    },
    emailValidator(email) {
      if (email === "") {
        this.$refs.email.$el.style.borderColor = "red";
        return false;
      }
      const result = /\S+@\S+\.\S+/.test(email);
      this.$refs.email.$el.style.borderColor = result ? "#e8e8e8" : "red";
      return result;
    },
    passwordValidator(password) {
      if (password === "" || password.length < 6) {
        this.$refs.password.$el.style.borderColor = "red";
        return false;
      }
      this.$refs.password.$el.style.borderColor = "#e8e8e8";
      return true;
    },
    confirmPasswordValidator(password) {
      if (password === "" || password.length < 6 || password !== this.password) {
        this.$refs.confirmPassword.$el.style.borderColor = "red";
        return false;
      }

      this.$refs.confirmPassword.$el.style.borderColor = "#e8e8e8";
      return true;
    },
    async onEmailNext() {
      this.$refs.emailForm.validate().then(async () => {
        this.$refs.email.$el.style.borderColor = "#e8e8e8";
        //校验通过，发送邮件
        try {
          const userStatus = await user.checkAccountStatus({ email: this.email }, true);
          this.userStatus = userStatus;
          if (this.userStatus.registerStatus === 1) {
            this.step += 2;
          } else {
            const result = await this.onSendEmailVerification();
            if (result) {
              this.step += 1;
            }
          }
        } catch (e) {
          console.log(e);
          this.$toast({
            type: "fail",
            message: e
          });
        }
      }).catch(e => {
        console.log(e);
        this.$refs[e[0].name].$el.style.borderColor = "red";
      });
    },

    onPasswordNext() {

      if (this.isForgetPassword) {
        this.$refs.passwordForm.validate().then(() => {
          this.step += 1;
        }).catch(e => {
          console.log(e);
          this.$refs[e[0].name].$el.style.borderColor = "red";
        });
      }else {
        const invitationCode = this.invitationCode;
        if (invitationCode.length > 0 && invitationCode.length < 4) {
          this.$toast({
            type: "fail",
            message: "Invalid invitation code"
          });
          return;
        }
        this.$refs.passwordForm.validate().then(() => {
          this.$refs.password.$el.style.borderColor = "#e8e8e8";
          //校验通过，发送邮件
          if (this.userStatus.registerStatus === 1) {
            this.onClickLogin();
          } else {
            this.step += 1;
          }
        }).catch(e => {
          console.log(e);
          this.$refs[e[0].name].$el.style.borderColor = "red";
        });
      }
    },
    onRenterPasswordNext() {
      this.$refs.renterPasswordForm.validate().then(async () => {
        this.$refs.confirmPassword.$el.style.borderColor = "#e8e8e8";
        if (this.isForgetPassword) {
            await this.onForgetPassword()
        }else {
          await this.onRegister();
        }

      }).catch(e => {
        console.log(e);
        this.$refs[e[0].name].$el.style.borderColor = "red";
      });
    },

    onInvitationCodeChange(value) {
      this.invitationCode = value;
    },

    onRegisterEmailCodeChange(value) {
      this.emailCode = value;
    },
    async onCompleteVerificationCode(value) {
      if (this.isCaptchaSumbiting) {
        return;
      }
      try {
        this.isCaptchaSumbiting = true;

        if (this.isForgetPassword) {
          const resp = await user.verificationCode({
            email: this.email,
            code: value
          });

          this.emailCode = value;
          this.$toast({
            type: "success",
            message: resp.message
          });
          this.step += 1;
        }else {
          const resp = await user.verificationCodeCheck({
            email: this.email,
            code: value
          });

          this.$toast({
            type: "success",
            message: resp.message
          });
          this.step += 1;
        }



      } catch (e) {
        this.$toast({
          type: "fail",
          message: e
        });
      } finally {
        this.isCaptchaSumbiting = false;
      }
    },

    async onSendEmailVerification() {
      if (this.isForgetPassword) {
        this.onForgetPasswordClick()
        return
      }
      try {
        const resp = await user.sendEmailVerification({ email: this.email }, true);
        this.$toast({
          type: "success",
          message: resp.message
        });
        return true;
      } catch (e) {
        this.$toast({
          type: "fail",
          message: e
        });
        return false;
      }
    },

    onClickEye() {
      this.passwordVisible = !this.passwordVisible;
      if (this.passwordType === "password") {
        this.passwordType = "text";
      } else {
        this.passwordType = "password";
      }
    },
    onClickConfirmEye() {
      this.confirmPasswordVisible = !this.confirmPasswordVisible;
      if (this.confirmPasswordType === "password") {
        this.confirmPasswordType = "text";
      } else {
        this.confirmPasswordType = "password";
      }
    },
    async onClickLogin() {
      try {
        const resp = await this.$api.User.doLogin({
          userName: this.email,
          password: this.password,
          invitationCode: this.invitationCode, //9165
          identityConfirmStatus: this.$route.query.identityConfirmStatus
        });

        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }

        const user = resp.data;
        window.localStorage.setItem("omni-token", user.token);
        this.$store.commit("user/setLoginInfo", user);

        if (user.supplierId === 0) {
          if (!user.agreementReadStatus) {
            this.$router.replace("/PrivacyPolicy");
            return;
          }
          this.$router.replace("/Enterprise");
          return;
        } else {
          if (user.identityConfirmStatus === 0) { //没确认身份跳转到确认身份
            this.$router.push("/LoginOptions");
            return;
          }
          if (!user.agreementReadStatus) {
            this.$router.replace("/PrivacyPolicy");
            return;
          }
        }

        this.$router.replace("/Enterprise");


      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }


      // this.$api.User.doLogin({
      // })
      //     .then(res => {
      //       log(res);
      //       if (res.code === 200) {
      //
      //       } else {
      //         window.localStorage.setItem("omni-token", "");
      //         this.$store.commit("user/setLoginInfo", null);
      //         this.$toast(res.message);
      //       }
      //     })
      //     .catch(error => {
      //       console.log(error);
      //       window.localStorage.setItem("omni-token", "");
      //       this.$store.commit("user/setLoginInfo", null);
      //       this.$toast(error);
      //     });
    },

    async onRegister() {
      try {
        const resp = await this.$api.User.registerUser({
          email: this.email,
          invitationCode: this.invitationCode,
          password: this.password
        });


        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }

        const user = resp.data;
        window.localStorage.setItem("omni-token", user.token);
        this.$store.commit("user/setLoginInfo", user);


        if (user.identityConfirmStatus === 0) { //没确认身份跳转到确认身份
          this.$router.push("/LoginOptions");
          return;
        }

        this.$router.replace("/PrivacyPolicy");

      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },

    async onForgetPassword() {
      try {

        const resp = await this.$api.User.retrievePassword({
          email: this.email,
          code: this.emailCode,
          password: this.password
        });

        if (resp.code !== 200) {
          this.$toast({
            type: "fail",
            message: resp.message
          });
          return;
        }

        this.$toast({
          type: "success",
          message: resp.message
        });
        this.step = 1
        this.isForgetPassword = false
      } catch (e) {
        console.log(e);
        this.$toast({
          type: "fail",
          message: e
        });
      }
    },


    onClickResetIt() {
      this.$refs.password.style.background = "#e8eff2";
      this.$refs.password.style.border = "none";
      this.password = "";
      this.errorCode = "";
      this.passwordError = false;
    },
    onClickCreate() {
      this.$router.push({ name: "Register", query: { hash: this.$store.state.hash } });
    },
    onClickForgot() {
      this.$router.push({ name: "Retrieve", query: { hash: this.$store.state.hash } });
    },
    onFocusEmail() {
      this.$refs.email.style.background = "#e8eff2";
      this.$refs.email.style.border = "none";
      this.errorCode = "";
    },
    onAgreeChange(e) {
      this.checkedPrivacyPolicy = e;
    }
  },
  watch: {
    checkedPolicy(val) {
      this.checkedPrivacyPolicy = val;
    }
  },
  mounted() {
    document.body.style.background = "white";
    this.checkedPrivacyPolicy = this.checkPrivacy;

  },
  destroyed() {
  }
};
</script>

<style lang="less" scoped>
.container {
  background: white;
}

.content {
  display: flex;
  height: 100%;
  margin-top: 198px;
  flex-direction: column;
  padding: 0 25px;
  background: white;
  color: #999999;
  font-size: 14px;

  .email {
    border: 1px solid transparent;
  }

  .password {
    margin-top: 9px;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;

    input {
      border: 1px solid transparent;
    }

    .password-input {
      width: 90% !important;
    }

    .fa {
      position: absolute;
      right: 40px;
      width: 31px;
      height: 20px;
    }

    .fa-visible {
      position: absolute;
      right: 40px;
      width: 32px;
      height: 29px;
    }
  }

  .emptyError {
    background: #f4e6e9 !important;
    border: 1px solid #e08cae !important;
  }

  .errormsg {
    margin-top: 9px;
    font-size: 16px;
    font-weight: normal;
    color: #d66384;

    span {
      text-decoration: underline;
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      -webkit-user-select: none;
      -moz-user-focus: none;
      -moz-user-select: none;
    }
  }

  .operate {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .button-login {
    width: 70%;
    color: white;
    margin-top: 28px;
    transition: opacity 0.2s;
    -webkit-appearance: none;
    background: var(--themeMainColor);
  }

  .button-login:active {
    opacity: 0.8;
    -webkit-tap-highlight-color: transparent;
  }

  .forgot {
    margin-top: 19px;
    font-size: 18px;
    font-weight: normal;
    color: #231f20;
  }

  .create {
    margin-top: 35px;
    font-size: 18px;
    font-weight: normal;
    color: #231f20;
  }
}

.footer {
  width: 100%;
  text-align: center;
  position: fixed;
  font-size: 18px;
  color: #BCBDBF;
  bottom: 50px;
}

.privacy-policy {
  margin-top: 20px;
  font-size: 14px;

  .policy-item {
    color: var(--themeMainColor);
  }
}

::v-deep .van-checkbox {
  align-items: flex-start;
}

::v-deep .van-cell {
  background: transparent;
  padding: 0px 12px;
  border: 1px solid #E8E8E8;
  border-radius: 12px;

  .van-field__body {
    .van-field__button {
      display: flex;
      flex-direction: row;
      align-items: center;

    }

    input {
      padding: 0 !important;
      border-radius: 0 !important;
    }

    .van-icon__image {
      width: 24px;
      height: 24px;
    }
  }
}

input[type='tel'] {
  display: block;
  flex: 1;
  width: 35px;
  outline: none;
  font-size: 16px;
  background: transparent;
  border: none;
  color: #333333;
  border-bottom: 2px solid #E8E8E8;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.6s;
  border-radius: 0;
  margin-right: 8px;

  &:last-child {
    margin-right: 0;
  }

  //&:focus {
  //  border-color: #333;
  //}
}


</style>
